module.exports = __webpack_public_path__ + "fonts/iconfont.b3dd10b5.woff";